import { useContext } from "react";
import { CompareContext } from "@/contexts/compare";

export const useCompare = () => {
  const context = useContext(CompareContext);
  if (context === undefined) {
    throw new Error("useCompare must be used within a CompareProvider");
  }
  return context;
};
